import { createAction, props } from '@ngrx/store';

import { SearchSettingsResponse } from '@offconon/core-api';

import { MenuSettings } from './search-settings.models';

export const setUserSearchSettings = createAction(
  '[Core/Search Settings] Set User Search Settings',
  props<{
    searchSettings: Partial<SearchSettingsResponse> | undefined;
  }>(),
);

export const fetchMenuSettingList = createAction('[Core/Search Settings] Fetch Menu Setting List');
export const fetchMenuSettingListSuccess = createAction(
  '[Core/Search Settings] Fetch Menu Setting List Success',
  props<{ menuSettings: MenuSettings[] }>(),
);

export const editMenuSetting = createAction(
  '[Core/Search Settings] Edit Menu Setting',
  props<{ menuSetting: MenuSettings }>(),
);

export const editMenuSettingSuccess = createAction(
  '[Core/Search Settings] Edit Menu Setting Success',
  props<{ menuSetting: MenuSettings }>(),
);

export const setLoaded = createAction(
  '[Core/Search Settings] Set Loaded',
  props<{ loaded: boolean }>(),
);
